<template>
  <div class="card-form">
    <page-main
      ref="main"
      :table-data="table"
      :loading="loading"
      @submit="reload"
      :tablePage="page"
      @batchDel="submitDel"
    >
      <page-header
        @reset="reset"
        slot="header"
        @submit="handleSubmit"
        @batchDel="batchDel"
        @openProjectListDialog="openProjectListDialog"
        ref="header"
      >
      </page-header>
      <pagination
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        size="small"
        align="right"
        slot="pager"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      @opened="opened"
      width="800px"
    >
      <project-list ref="form" @success="saveSuccess"></project-list>
    </el-dialog>
  </div>
</template>

<script>
const initPage = {
  curPage: 1,
  pageSize: 20,
  pageTotal: 0,
};

export default {
  name: "personal-myShoppingCart-sample",
  components: {
    PageHeader: () => import("./components/header"),
    PageMain: () => import("./components/main"),
    ProjectList: () => import("../../../components/project"),
  },
  data() {
    return {
      table: [],
      page: { ...initPage },
      loading: false,
      formOption: {
        title: "",
        dialogFormVisible: false,
      },
      assignParams: {
        val: "",
        val2: "",
      },
    };
  },
  methods: {
    reset() {
      this.page = {
        ...initPage,
      };
    },
    // 分页查询
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      };
      this.$nextTick(() => {
        this.$refs.header.query();
      });
    },
    // 重载表格数据
    reload() {
      this.$refs.header.onReset();
    },
    // 加载表格数据
    handleSubmit(form) {
      this.loading = true;
      this.$api
        .deListCartApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false;
          this.page.pageTotal = res.body.count;
          this.table = res.body.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //批量删除的操作
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords();
      if (listCode) this.submitDel(listCode);
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l("INDEX.tips_delete") || "是否要删除该记录？",
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api.delCartApi({ cartCodeList:listCode }).then(() => {
            this.$message({
              showClose: true,
              message: this.$l("INDEX.tips_delete_ok") || "删除成功！",
              type: "success",
            });
            this.$refs.header.query();
          });
        })
        .catch(() => {});
    },
    //批量操作的其他功能
    openProjectListDialog({val, val2}) {
      const listCode = this.$refs.main.getCheckboxRecords("");
      if (!listCode) return;
      let productList = [];
      listCode.forEach((item) => {
        productList.push({
          productType: val,
          productCode: item.sampleCode,
        });
      });
       this.assignParams = {
        val: productList,
        val2: val2,
      };
      // 设置标题
      this.formOption.title = this.$l("project_page_title") || "项目列表";
      this.formOption.dialogFormVisible = true;
    },
    opened() {
      this.$refs.form.getData(this.assignParams);
    },
    //保存之后执行的的操作
    saveSuccess() {
      this.cancel();
      this.batchDel();
    },
    cancel() {
      this.formOption.dialogFormVisible = false;
    },
  },
};
</script>
